import React, { FC, ImgHTMLAttributes, useEffect, useState } from 'react';
import { NotificationsItemImg } from './styled';
import { Skeleton } from '@material-ui/lab';

const fallbackImage = 'https://www.lernova.be/hubfs/getuigenis%20tamara.jpg';

export const NotificationsImage: FC<ImgHTMLAttributes<HTMLImageElement>> = ({
  src,
  alt,
  onClick,
}) => {
  const [imgSrc, setImgSrc] = useState(src);
  const [loading, setLoading] = useState(true);

  const handleImageError = () => {
    setImgSrc(fallbackImage);
  };

  const handleImageLoad = () => {
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
  }, [src]);

  return (
    <>
      {loading && (
        <Skeleton variant="rect" width="100%" height="auto" style={{ aspectRatio: '16/9' }} />
      )}
      <NotificationsItemImg
        onClick={onClick}
        alt={alt}
        src={imgSrc}
        onError={handleImageError}
        onLoad={handleImageLoad}
        style={{ display: loading ? 'none' : 'block' }}
      />
    </>
  );
};
